// Datos de contacto y redes sociales del negocio.
//
// ESTE ES EL UNICO LUGAR donde viven el telefono, el correo, la direccion y
// las URLs de redes. Si cambia alguno, se cambia aqui y se actualiza en todo
// el sitio (footer, pagina de contacto, jardin, boton flotante de WhatsApp).
// No vuelvas a escribirlos a mano en un componente.

// El telefono se guarda una sola vez en formato E.164 y de ahi se derivan
// las demas formas, para que no puedan quedar desincronizadas entre si.
const PHONE_E164 = '+523113970550';
const EMAIL = 'jardinyvillalafinca@gmail.com';

export const CONTACT = {
  /** Como se muestra en pantalla */
  phoneDisplay: '+52 311 397 0550',
  /** Para <a href> — sin espacios */
  phoneHref: `tel:${PHONE_E164}`,
  /** wa.me exige el numero sin '+' ni separadores */
  whatsappUrl: `https://wa.me/${PHONE_E164.replace(/\D/g, '')}`,

  email: EMAIL,
  emailHref: `mailto:${EMAIL}`,

  addressLine1: 'La Lava #2, esquina Leopoldo Álvarez Rodríguez',
  addressLine2: 'San Cayetano, Nayarit, México 63511',
};

/**
 * Enlace de WhatsApp con un mensaje ya escrito en la caja de texto.
 * El usuario todavia tiene que pulsar enviar: wa.me solo precarga el texto.
 */
export function whatsappLink(message) {
  return `${CONTACT.whatsappUrl}?text=${encodeURIComponent(message)}`;
}

export const SOCIAL = {
  instagram: 'https://www.instagram.com/jardinyvillalafinca/',
  facebook: 'https://www.facebook.com/jardinvillalafinca/',
  tiktok: 'https://www.tiktok.com/@jardinyvillalafinca',
};
